import React from 'react';

import type { HandlingUnits } from '@bringg/types';

import useStore from '../../../stores/helpers/use-context';

import styles from './max-handling-units.module.scss';

interface Props {
	maxHandlingUnits: HandlingUnits;
}

const MaxHandlingUnits = (props: Props) => {
	const { allConfiguration } = useStore();
	const { handlingUnits: handlingUnitsName } = allConfiguration || {};

	const getMaxHandlingUnits = maxHandlingUnits => {
		const result = [];

		if (!maxHandlingUnits || !handlingUnitsName) return;

		for (const [key, value] of Object.entries(maxHandlingUnits as HandlingUnits)) {
			result.push(
				<div key={key} className={styles.maxHandlingUnitRow}>
					<span className={styles.maxHandlingUnitName} data-test-id="max-handling-unit-name">
						{handlingUnitsName[key]?.name}:
					</span>
					<span data-test-id="max-handling-unit-value">{Math.round(value * 100) / 100}</span>
				</div>
			);
		}
		return result;
	};

	return <div className={styles.maxHandlingUnitColumn}>{getMaxHandlingUnits(props.maxHandlingUnits)}</div>;
};

export default MaxHandlingUnits;
